<template>
  <div>
    <div class="productBox warp">
      <div class="productConcise clearfix">
        <div class="swiper-box" style="height: 560px">
          <!-- swiper1 -->
          <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
            <swiper-slide v-for="(item) of productDetailData.images" :key="item" :style="{backgroundImage: 'url('+ item +')'}"></swiper-slide>
          </swiper>
          <!-- swiper2 Thumbs -->
          <div class="swiperThumbsLeft">
            <div class="thumbsBox">
              <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
                <swiper-slide v-for="(item, index) of productDetailData.images" :key="index" :style="{backgroundImage: 'url('+ item +')'}">
                  <div style="width: 100%; height: 100%;" @click="thumbsClick(index)"></div>
                </swiper-slide>
              </swiper>
              <div class="swiper-button-prev swiper-button-white iconfont" slot="button-prev">&#xe660;</div>
              <div class="swiper-button-next swiper-button-white iconfont" slot="button-next">&#xe695;</div>
            </div>
          </div>
        </div>
        <div class="proDuctInfo">
          <h3 class="productTit">{{productDetailData.productName}}</h3>
          <p class="introduction">{{productDetailData.productBrief}}</p>
          <div class="priceDataInfo">
            <div v-if="currentProductData.activityType===1">
              <div class="groupBuyInfo">
                <div class="groupLeft">
                  <i class="iconfont">&#xe64a;</i>
                  <span>拼团专区</span>
                </div>
                <div class="groupRight" v-if="ifEnable===0">{{productDetailData.person}}人团</div>
                <div class="groupRight" v-else>{{productOption.skuTool.startTime}} 活动开启</div>
              </div>
              <div class="priceSpike mar-bot-20">
                <div class="priceSpikeLeft">
                  拼团价：<b>￥{{currentProductData.price}}</b><span>￥{{currentProductData.originalPrice}}</span>
                </div>
              </div>
            </div>
            <div v-if="currentProductData.activityType===2">
              <div class="groupBuyInfo">
                <div class="groupLeft">
                  <i class="iconfont">&#xe64a;</i>
                  <span>秒杀专区</span>
                </div>
                <div class="countdown" v-if="ifEnable===0">
                  <div class="countdownTit">距离结束:</div>
                  <div class="timeDown">
                    <span class="time">{{endTime | formatHours}}</span>
                    <span>:</span>
                    <span class="time">{{endTime | formatMinutes}}</span>
                    <span>:</span>
                    <span class="time">{{endTime | formatSeconds}}</span>
                  </div>
                </div>
                <div class="groupRight" v-else>{{productOption.skuTool.startTime}} 活动开启</div>
              </div>
              <div class="priceSpike mar-bot-20">
                <div class="priceSpikeLeft">
                  秒杀价：<b>￥{{currentProductData.price}}</b><span>￥{{currentProductData.originalPrice}}</span>
                </div>
                <div class="priceSpikeRight" v-if="productDetailData.total && ifEnable === 0">
                  <span>限量{{productDetailData.total}}件/还剩{{productDetailData.surplusNumber}}件</span>
                  <el-progress :text-inside="true" :stroke-width="10" :percentage="(productDetailData.total-productDetailData.surplusNumber)/productDetailData.total*100" status="exception"></el-progress>
                </div>
              </div>
            </div>
            <div v-if="currentProductData.activityType===3">
              <div class="groupBuyInfo">
                <div class="groupLeft">
                  <i class="iconfont">&#xe64a;</i>
                  <span>限时折扣</span>
                </div>
                <div class="countdown" v-if="ifEnable===0">
                  <div class="countdownTit">距离结束:</div>
                  <div class="timeDown">
                    <span class="time">{{endTime | formatHours}}</span>
                    <span>:</span>
                    <span class="time">{{endTime | formatMinutes}}</span>
                    <span>:</span>
                    <span class="time">{{endTime | formatSeconds}}</span>
                  </div>
                </div>
                <div class="groupRight" v-else>{{productOption.skuTool.startTime}} 活动开启</div>
              </div>
              <div class="priceSpike mar-bot-20">
                <div class="priceSpikeLeft">
                  折扣价：<b>￥{{currentProductData.price}}</b><span>￥{{currentProductData.originalPrice}}</span>
                </div>
                <div class="priceSpikeRight" v-if="productDetailData.total && ifEnable === 0">
                  <span>限量{{productDetailData.total}}件/还剩{{productDetailData.surplusNumber}}件</span>
                  <el-progress :text-inside="true" :stroke-width="10" :percentage="(productDetailData.total-productDetailData.surplusNumber)/productDetailData.total*100" status="exception"></el-progress>
                </div>
              </div>
            </div>
            <div class="promotionInfo" v-if="currentProductData.activityType===0">
              <span>价格:</span>
              <span>￥{{ currentProductData.price }}</span>
              <span>￥{{ currentProductData.originalPrice }}</span>
            </div>
            <div class="proDiscount">
              <div class="activityLabel" v-for="(item, index) of productDetailData.markTools" :key="item.couponId">
                <span>{{item.activityName}}</span>
                <span>优惠券：{{item.content}}</span>
                <span @click="getThisCoupon(item, index)">{{item.state === 3 ? '领取' : '已领取'}}</span>
              </div>
              <div class="activityLabel" v-for="(item, index) of productDetailData.shopMarkTools" :key="item.shopCouponId">
                <span>{{item.activityName}}</span>
                <span>优惠券：{{item.content}}</span>
                <span @click="getThisCoupon1(item, index)">{{item.state === 3 ? '领取' : '已领取'}}</span>
              </div>
            </div>
          </div>
          <!-- <div class="productColor">
            <div class="proDescribeTit">{{ productColor.skuName }}：</div>
            <div class="proColorList">
             <div :style="{borderColor: productInfo.currentColor === index ? item.value : '#FFF'}" v-for="(item, index) of colorList" :key="index"><span :style="{background: item.value}"></span></div>
              <div :style="{borderColor: productInfo.currentColor === index}" v-for="(item, index) of productOption.map" :key="index"><span><img
                :src="item.image" alt=""></span></div>
            </div>
          </div> -->
          <!-- <div class="productSize">
            <div class="proDescribeTit">码数：</div>
            <div class="proSizeList">
              <span :class="{sizeActive: productInfo.currentSize === index}" v-for="(item, index) of productSize" :key="index">{{item.size}}</span>
            </div>
          </div> -->
          <div class='sku-box'>
            <ul v-for='it in productOption.names' :key='it.nameCode'>
              <li>
                <p class="proDescribeTit">{{it.skuName === '' ? '' : it.skuName + ':'}}</p>
                <p>
                  <span
                    @click='selectSku(kt, it)'
                    v-for='kt in it.values'
                    :key='kt.valueCode'
                    :class="[{'selected-item': kt.selected}]">
                    <el-image
                      v-if="kt.image" :src="kt.image"
                      :preview-src-list="[kt.image]" :alt="kt.skuValue" style="width: 32px; height: 32px;text-align: left;">
                    </el-image>
<!--                    <img v-if="kt.image" :src="kt.image" :alt="kt.skuValue">-->
                    {{kt.skuValue }}
                  </span>
                </p>
              </li>

            </ul>
          </div>
          <div class="productNumber">
            <div class="proDescribeTit">数量：</div>
            <div class="proNumberList">
              <el-input-number v-model="productNumber" :min="1" :max="currentProductData.stockNumber" label="库存"></el-input-number>
              <span>库存<b>{{currentProductData.stockNumber}}</b>件</span>
            </div>
          </div>
          <div class="btnBox">
            <div class="buyBox" v-if="currentProductData.activityType===0 && currentProductData.stockNumber!==0 && productDetailData.shelveState">
              <span @click="clickAddCart">加入购物车</span>
              <span @click='buyGood'>购买</span>
            </div>
            <div class="buyBox" v-if="currentProductData.activityType===2 && currentProductData.stockNumber!==0 && productDetailData.shelveState || currentProductData.activityType===3 && currentProductData.stockNumber!==0 && productDetailData.shelveState">
              <span @click="clickAddCart" v-if="ifEnable===1">加入购物车</span>
              <span @click='buyGood'>购买</span>
            </div>
            <div class="favorites" v-if="currentProductData.activityType===1 && currentProductData.stockNumber!==0 && productDetailData.shelveState">
              <span class="oddBuy" @click="buyGood" v-if="ifEnable===0">单独购买</span>
              <span class="StartGroup" @click="openGroup(1)" v-if="ifEnable===0">我要开团</span>
              <span @click="clickAddCart" v-if="ifEnable===1">加入购物车</span>
              <span @click='buyGood' v-if="ifEnable===1">购买</span>
            </div>
            <div class="noStock" v-if="currentProductData.stockNumber===0 && productDetailData.shelveState">
              <span>已售空</span>
            </div>
            <div class="noStock" v-if="!productDetailData.shelveState">
              <span>已下架</span>
            </div>
            <div class="favoritesBtn" @click="collect">
              <img style="width:18px;height:18px;margin-top:3px;" v-if="productDetailData.ifCollect === 0" src="../../../static/image/sc0.png" alt="">
              <img style="width:18px;height:18px;margin-top:3px;" v-else src="../../../static/image/sc1.png" alt="">
              <span>收藏</span>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="pinList" v-if="currentProductData.activityType===1 && productDetailData.collageOrders.length && ifEnable===0">
          <div class="fightOrderTit">
            <i class="iconfont">&#xe64c;</i>
            <span>这些人正在拼单</span>
          </div>
          <div class="pinListBox">
            <div class="pinItem" v-for="(item) in productDetailData.collageOrders" :key="item.collageId">
              <div class="Avatar">
                <img :src="item.headImage" alt="">
              </div>
              <div class="pinUserInfo">
                <span class="pUserName">{{item.name}}</span>
                <span class="notBad">还差<b>{{item.person}}</b>人拼成</span>
                <span class="remainingTime">剩余：<b>{{item.time | formatTime}}</b></span>
              </div>
              <div v-if="!item.lock" class="pinBtn" @click="goToGroupBuy(item.collageId)">和Ta拼</div>
              <div v-else class="pinBtn">已结束</div>
            </div>
          </div>
        </div>
      </div>
<!--      <div class="productDetail">-->
<!--        <div class="detailTabs">-->
<!--          <span :class="{compActive: currentComp === 'detailData'}" @click="clickSwitchTab(type = 'detailData')">宝贝详情</span>-->
<!--          <span :class="{compActive: currentComp === 'evaluation'}" @click="clickSwitchTab(type = 'evaluation')">商品评论</span>-->
<!--        </div>-->
<!--        <div class="detailBox clearfix">-->
<!--          <div class="detailInfoBox">-->
<!--            <component :is="currentComp"></component>-->
<!--          </div>-->
<!--          <div class="likeProductBox">-->
<!--            <like-list></like-list>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="productDetail">
        <div class="detailTabs">
          <span :class="{compActive: currentComp === 'detailData'}" @click="clickSwitchTab(type = 'detailData')">宝贝详情</span>
          <span :class="{compActive: currentComp === 'evaluation'}" @click="clickSwitchTab(type = 'evaluation')">商品评论</span>
          <span :class="{compActive: currentComp === 'productAnswer'}" @click="clickSwitchTab(type = 'productAnswer')">商品问答</span>
        </div>
         <div class="detailBox clearfix">
           <div class="detailInfoBox">
             <div v-show="currentComp==='detailData'">
               <div class="detailBox">
                 <div class="detailCont" v-html="productDetailData.text"></div>
               </div>
             </div>
             <div v-show="currentComp==='evaluation'">
               <evaluation v-if="evaluateParam.productId !== ''" :evaluateParam="evaluateParam"></evaluation>
             </div>
             <div v-show="currentComp==='productAnswer'">
               <product-answer></product-answer>
             </div>
           </div>
           <div class="likeProductBox">
             <like-list @reloadDetail="reloadDetail" :similarProducts="similarProducts"></like-list>
           </div>
         </div>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="groupBuyDialog"
      width="30%"
      :before-close="groupBuyClose">
      <span>是否跟他拼团？</span>
      <span slot="footer" class="dialog-footer">
    <el-button @click="groupBuyClose">取 消</el-button>
    <el-button type="primary" @click="openGroup(0)">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import detailData from './detailData'
import evaluation from './evaluation'
import likeList from './likeList'
import ProductAnswer from './productAnswer'
import 'swiper/dist/css/swiper.css'
import CereHeader from '../../components/canvasShow/cereshop/pc/header'
import api from '../../api'
import { listSearchMixin } from '../../config/mixin'
import {mapMutations} from 'vuex'
import Cookie from 'js-cookie'
export default {
  name: 'productDetail',
  mixins: [listSearchMixin],
  components: {
    ProductAnswer,
    CereHeader,
    swiper,
    swiperSlide,
    detailData,
    evaluation,
    likeList
  },
  inject: ['reload'],
  data () {
    return {
      currentComp: 'detailData',
      swiperTop: null,
      swiperThumbs: null,
      swiperOptionTop: {
        spaceBetween: 10,
        loop: true,
        loopedSlides: 20
      },
      swiperOptionThumbs: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        direction: 'vertical',
        spaceBetween: 10,
        slidesPerView: 3,
        loop: true,
        freeMode: true,
        loopedSlides: 20, // looped slides should be the same
        centeredSlides: true,
        watchSlidesVisibility: true
      },
      productSizeData: {},
      productColor: {},
      productDetailData: {},
      activeName: 'Detail',
      productOption: {},
      evaluateParam: {
        productId: '',
        words: []
      },
      similarProducts: [],
      productPrice: '',
      originalPrice: '',
      // currentProductData: {
      //   productPrice: '',
      //   originalPrice: '',
      //   stockNumber: '',
      //   activityType: ''
      // },
      currentProductData: {},
      productNumber: 1,
      // 商品问答
      productAnswerList: [
        {
          id: 1
        }
      ],
      priceSpikezNum: 100,
      groupBuyDialog: false,
      setTime: null,
      setTime1: null,
      collageId: null,
      ifEnable: null,
      endTime: '',
      currentPro: JSON.parse(this.$route.query.proData)
    }
  },
  filters: {
    formatHours: function (value) {
      let hours = Math.floor(value / (1000 * 60 * 60))
      if (hours < 10) {
        return '0' + hours
      } else {
        return hours
      }
    },
    formatMinutes: function (value) {
      let minutes = Math.floor((value % (1000 * 60 * 60)) / (1000 * 60))
      if (minutes < 10) {
        return '0' + minutes
      } else {
        return minutes
      }
    },
    formatSeconds: function (value) {
      let seconds = Math.round((value % (1000 * 60)) / 1000)
      if (seconds < 10) {
        return '0' + seconds
      } else {
        return seconds
      }
    },
    formatTime: function (value) {
      let hours = Math.floor(value / (1000 * 60 * 60))
      let minutes = Math.floor((value % (1000 * 60 * 60)) / (1000 * 60))
      let seconds = Math.round((value % (1000 * 60)) / 1000)
      if (hours < 10) {
        hours = '0' + hours
      }
      if (minutes < 10) {
        minutes = '0' + minutes
      }
      if (seconds < 10) {
        seconds = '0' + seconds
      }
      return hours + ':' + minutes + ':' + seconds
    }
  },
  created () {
    this.getShopIndex()
    this.getProductInfo()
  },
  mounted () {
    this.$nextTick(() => {
      this.swiperTop = this.$refs.swiperTop.swiper
      this.swiperThumbs = this.$refs.swiperThumbs.swiper
      this.swiperTop.controller.control = this.swiperThumbs
      this.swiperThumbs.controller.control = this.swiperTop
    })
  },
  destroyed () {
    clearInterval(this.setTime)
    clearInterval(this.setTime1)
  },
  methods: {
    ...mapMutations({
      setCartNumber: 'SET_CARTNUMBER',
      setShoppingCart: 'SET_SHOPPINGCART',
      setCollectData: 'SET_COLLECTDATA'
    }),
    // 活动倒计时
    countDown () {
      clearInterval(this.setTime)
      this.setTime = setInterval(() => {
        if (this.endTime > 1000) {
          this.endTime -= 1000
        } else {
          this.endTime = 0
          clearInterval(this.setTime)
          alert('活动已结束')
          window.location.reload()
        }
      }, 1000)
    },
    // 拼团倒计时
    countDown1 () {
      clearInterval(this.setTime1)
      this.setTime1 = setInterval(() => {
        this.productDetailData.collageOrders.map(item => {
          if (item.time > 1000) {
            item.time -= 1000
          } else {
            this.$set(item, 'lock', true)
            item.time = 0
          }
        })
      }, 1000)
    },
    // 获取店铺信息
    getShopIndex () {
      let params = {
          url: api.getShopIndex + `?shopId=${this.currentPro.shopId}`,
          method: 'GET'
        }
        this.sendReq(params, (res) => {
          if (res.code === '200') {
            let data = {
              ifCollect: res.data.ifCollect,
              collectId: res.data.collectId,
              shopAdress: res.data.shopAdress,
              shopName: res.data.shopName,
              shopId: res.data.shopId,
              classifyNumber: res.data.classifyNumber,
              number: res.data.number,
              shopLogo: res.data.shopLogo
            }
            this.setCollectData(data)
          }
        })
    },
    // 获取商品详情
    getProductInfo () {
      const rLoading = this.openLoading()
      // console.log(this.currentPro, 'productData')
      let self = this
      let params = {
        url: api.getProDetail,
        method: 'GET',
        payload: {
          shopId: self.currentPro.shopId,
          productId: self.currentPro.productId,
          skuId: self.currentPro.skuId,
          terminal: '3',
          system: '3',
          city: ''
        }
      }
      self.sendReq(params, (res) => {
        if (res.code === '200') {
          self.productDetailData = res.data
          self.evaluateParam.productId = self.productDetailData.productId
          self.evaluateParam.words = self.productDetailData.words
          self.similarProducts = self.productDetailData.similarProducts
          self.getProOption()
          if (self.productDetailData.collageOrders.length) {
            self.countDown1()
          }
          window.scrollTo(0, 0)
          rLoading.close()
        } else {
          self.$message(res.message)
        }
      })
    },
    reloadDetail () {
      this.$router.go(0)
      // this.reload()
    },
    // 获取商品规格信息
    getProOption () {
      let self = this
      let params = {
        url: api.getProOption,
        method: 'GET',
        payload: {
          shopId: self.currentPro.shopId,
          productId: self.currentPro.productId
        }
      }
      self.sendReq(params, (res) => {
        if (res.code === '200') {
          self.productOption = res.data
          self.ifEnable = res.data.skuTool.ifEnable
          let nowTime = Date.now()
          self.endTime = new Date(res.data.skuTool.endTime).getTime() - nowTime
          if (res.data.names.length !== 0) {
            let sku = []
            for (var i in res.data.map) {
              if (res.data.map[i].skuId === self.currentPro.skuId) {
                self.currentProductData.stockNumber = res.data.map[i].stockNumber
                self.currentProductData.price = res.data.map[i].price
                self.currentProductData.originalPrice = res.data.map[i].originalPrice
                self.currentProductData.skuId = res.data.map[i].skuId
                self.currentProductData.activityType = res.data.map[i].activityType
                sku = i.split(',')
              }
            }
            let temp = true
            for (var j in res.data.map) {
              if (res.data.map[j].skuId === self.currentPro.skuId) {
                temp = false
              }
            }
            if (temp) {
              self.currentProductData.stockNumber = res.data.map[['attr_code_0_value_0']].stockNumber
              self.currentProductData.price = res.data.map[['attr_code_0_value_0']].price
              self.currentProductData.originalPrice = res.data.map[['attr_code_0_value_0']].originalPrice
              self.currentProductData.skuId = res.data.map[['attr_code_0_value_0']].skuId
              self.currentProductData.activityType = res.data.map[['attr_code_0_value_0']].activityType
              sku = ['attr_code_0_value_0']
            }
            sku.map(l => {
              res.data.names.map(j => {
                // j.values[0].selected = true
                j.values.map(k => {
                  if (k.valueCode === l) {
                    self.$set(k, 'selected', true)
                  }
                })
              })
            })
          } else {
            self.currentProductData.stockNumber = res.data.map['单款项'].stockNumber
            self.currentProductData.price = res.data.map['单款项'].price
            self.currentProductData.originalPrice = res.data.map['单款项'].originalPrice
            self.currentProductData.skuId = res.data.map['单款项'].skuId
            self.currentProductData.activityType = res.data.map['单款项'].activityType
          }
          // self.currentProductData.stockNumber = self.productOption.stockNumber
          // self.currentProductData.price = self.productOption.price
          // self.currentProductData.originalPrice = self.productOption.originalPrice
          // self.currentProductData.activityType = self.productDetailData.activityType
          self.productSizeData = res.data.names[0]
          self.productColor = res.data.names[1]
          if (self.endTime > 1000) {
            this.countDown()
          }
          // console.log(res.data.names, 'names')
        } else {
          self.$message(res.message)
        }
      })
    },
    // 加入购物车
    clickAddCart () {
      if (this.currentProductData.stockNumber > 0) {
        let self = this
        console.log(self.productOption, 'productOption')
        // if (self.productOption.names.length === 0) {
        //   var skuId = self.productOption.names[0].skuId
        // }
        let params = {
          url: api.addCart,
          method: 'POST',
          data: {
            // skuId: skuId || this.getSkuId(),
            skuId: self.currentProductData.skuId,
            number: self.productNumber
          }
        }
        self.sendReq(params, (res) => {
          if (res.code === '200') {
            self.$message.success('添加成功')
            self.getTrolleyList()
          } else {
            self.$message(res.message)
          }
        })
      } else {
        this.$message.warning('商品库存不足')
      }
    },
    // 购物车列表
    async getTrolleyList () {
      const vm = this
      const params = {
        url: api.getTrolleyList,
        method: 'GET'
      }
      vm.sendReq(params, res => {
        const d = res.data
        let cartNumber = 0
        if (d.length) {
          this.setShoppingCart(d)
          d.forEach(j => {
            cartNumber = cartNumber + j.skus.length
          })
        }
        this.setCartNumber(cartNumber)
      })
    },
    clickSwitchTab (type) {
      this.currentComp = type
    },
    handleClick (tab, event) {
      // console.log(tab, event)
    },
    // 购买
    buyGood () {
      if (this.currentProductData.stockNumber > 0) {
        if (!Cookie.get('token')) {
          this.$message.warning('请先登录')
          this.$store.commit('resetVuex')
          this.$router.push({path: '/login'})
        } else {
          // if (this.productOption.names.length === 0) {
          //   var skuId = this.productOption.names[0].skuId
          // }
          const o = this.productOption
          let shopsData = [
            {
              shopId: o.shopId,
              skus: [
                {
                  // skuId: skuId || this.getSkuId(),
                  skuId: this.currentProductData.skuId,
                  number: this.productNumber
                }
              ]
            }
          ]
          if (this.currentProductData.activityType === 2 && this.ifEnable === 0) {
            shopsData[0].shopSeckillId = this.productOption.skuTool.shopSeckillId
          } else if (this.currentProductData.activityType === 3 && this.ifEnable === 0) {
            shopsData[0].shopDiscountId = this.productOption.skuTool.shopDiscountId
          }
          let paramsType = null
          if (this.currentProductData.activityType === 0 || (this.currentProductData.activityType !== 0 && this.ifEnable === 1)) {
            paramsType = 0
          } else {
            paramsType = this.currentProductData.activityType
          }
          this.$router.push({
            path: '/placeOrder',
            query: {
              type: 1,
              ifWork: this.currentProductData.activityType === 1 && this.ifEnable === 0 ? 1 : 0,
              shops: JSON.stringify(shopsData),
              activityType: paramsType
            }})
        }
      } else {
        this.$message.warning('商品库存不足')
      }
    },
    // 拼团
    openGroup (x) {
      if (this.currentProductData.stockNumber > 0) {
        if (!Cookie.get('token')) {
          this.$message.warning('请先登录')
          this.$store.commit('resetVuex')
          this.$router.push({path: '/login'})
        } else {
          // if (this.productOption.names.length === 0) {
          //   var skuId = this.productOption.names[0].skuId
          // }
          const o = this.productOption
          let worksData = {
            shopId: o.shopId,
            number: this.productNumber,
            // skuId: skuId || this.getSkuId(),
            skuId: this.currentProductData.skuId,
            productId: this.productDetailData.productId,
            type: x ? 1 : 2
          }
          if (x) {
            worksData.shopGroupWorkId = this.productOption.skuTool.shopGroupWorkId
          } else {
            worksData.shopGroupWorkId = this.productOption.skuTool.shopGroupWorkId
            worksData.collageId = this.collageId
          }
          this.$router.push({path: '/placeOrder',
            query: {
              works: JSON.stringify(worksData),
              activityType: this.currentProductData.activityType
            }})
        }
      } else {
        this.$message.warning('商品库存不足')
      }
    },
    // 选择规格sku
    selectSku (o, list) {
      console.log(o, list, 'listo')
      const temp = this.productOption.names
      this.productNumber = 1
      if (list.values.length > 1) {
        temp.forEach(j => {
          if (j.nameCode === list.nameCode) {
            j.values.forEach(k => {
              this.$set(k, 'selected', k.valueCode === o.valueCode)
              console.log(temp)
            })
          }
        })
      }
      let selectOption = []
      temp.forEach(j => {
        j.values.forEach(k => {
          if (k.selected) {
            selectOption.push(k.valueCode)
          }
        })
      })
      let select = selectOption.toString()
      console.log(selectOption.toString(), 'selectOption')
      for (let key in this.productOption.map) {
        if (key === select) {
          this.currentProductData = this.productOption.map[key]
        }
      }
      console.log(this.currentProductData)
    },
    // 获取skuId
    // getSkuId () {
    //   const temp = this.productOption
    //   let id = ''
    //   temp.names.forEach(j => {
    //     j.values.forEach(k => {
    //       if (k.selected) id = ((id && `${id},`) || '') + k.valueCode
    //     })
    //   })
    //   return temp.map[id].skuId
    // },
    // 领取平台优惠券
    getThisCoupon (item, index) {
      if (item.state === 3) {
        let self = this
        let params = {
          url: api.takeCoupon,
          method: 'POST',
          data: {
            couponId: item.couponId
          }
        }
        self.sendReq(params, (res) => {
          if (res.code === '200') {
            self.$message.success('领取成功')
            item.state = 0
          } else {
            self.$message(res.message)
          }
        })
      }
    },
    // 领取店铺优惠券
    getThisCoupon1 (item, index) {
      console.log()
      if (item.state === 3) {
        let self = this
        let params = {
          url: api.takeCoupon,
          method: 'POST',
          data: {
            shopCouponId: item.shopCouponId
          }
        }
        self.sendReq(params, (res) => {
          if (res.code === '200') {
            self.$message.success('领取成功')
            item.state = 0
          } else {
            self.$message(res.message)
          }
        })
      }
    },
    // 拼团确认
    goToGroupBuy (id) {
      this.collageId = id
      this.groupBuyDialog = true
    },
    // 取消拼团
    groupBuyClose () {
      this.collageId = null
      this.groupBuyDialog = false
    },
    // 轮播图
    thumbsClick (index) {
      console.log(this.swiperTop)
      this.swiperThumbs.slideTo(index, 300, false)
      this.swiperTop.slideTo(index, 300, false)
    },
    // 收藏
    collect () {
      if (this.productDetailData.ifCollect === 0) {
        let params = {
          url: api.collect,
          method: 'POST',
          data: {
            productId: this.productDetailData.productId
          }
        }
        this.sendReq(params, (res) => {
          if (res.code === '200') {
            this.$message.success('收藏成功')
            this.productDetailData.ifCollect = 1
          }
        })
      } else {
        let params = {
          url: api.unfavorite,
          method: 'PUT',
          data: {
            ids: [this.productDetailData.collectId]
          }
        }
        this.sendReq(params, (res) => {
          if (res.code === '200') {
            this.$message.success('取消成功')
            this.productDetailData.ifCollect = 0
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.productBox {
  margin-top: 50px;
  .productConcise {
    margin-bottom: 60px;
    .swiper-box {
      width: 580px;
      position: relative;
      margin-right: 50px;
      float: left;
      .swiper-slide {
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        &.slide-1 {
          background-image:url('../../../static/image/tu1@2x.png');
        }
        &.slide-2 {
          background-image:url('../../../static/image/tu3@2x.png');
        }
        &.slide-3 {
          background-image:url('../../../static/image/tup2@2x.png');
        }
        &.slide-4 {
          background-image:url('../../../static/image/likeProduct1.png');
        }
        &.slide-5 {
          background-image:url('../../../static/image/poornetwork@2x.png');
        }
      }
      .gallery-top {
        height: 100%!important;
        width: 440px;
        position: absolute;
        right: 0;
      }
      .swiperThumbsLeft {
        width: 120px;
        position: absolute;
        left: 0;
        top: 10%;
        box-sizing: border-box;
        padding: 10px 0;
        height: 80%;
        .thumbsBox {
          width: 100%;
          height: 100%;
          position: relative;
          .swiper-button-prev,
          .swiper-button-next {
            position: absolute;
            left: 45px;
            background: none;
            width: 32px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            background: #999999;
            color: #FFFFFF;
          }
          .swiper-button-prev {
            position: absolute;
            top: -30px;
          }
          .swiper-button-next {
            position: absolute;
            top: initial;
            bottom: -50px;
          }
        }
      }
      .gallery-thumbs {
        position: relative;
        width: 100%;
        height: 100%;
      }
      .gallery-thumbs .swiper-slide {
        width: 100%;
        opacity: 0.7;
      }
      .gallery-thumbs .swiper-slide-active {
        opacity: 1;
        border: 1px solid $mainColor;
        box-sizing: border-box;
      }
    }
    .proDuctInfo {
      width: 578px;
      float: left;
      .productTit {
        font-size: 22px;
        color: #333333;
      }
      .introduction {
        color: #999999;
        font-size: 14px;
        line-height: 30px;
        margin: 10px 0;
      }
      .priceDataInfo {
        background: #FFF8F2;
        height: auto;
        .groupBuyInfo {
          display: flex;
          justify-content: space-between;
          background: #FF6B63;
          height: 32px;
          align-items: center;
          padding: 0 16px;
          .groupLeft {
            display: flex;
            color: #FFFFFF;
            align-items: center;
            i {
              font-size: 22px;
              margin-right: 5px;
            }
            span {
              font-family: YouSheBiaoTiHei;
              font-style: italic;
              font-weight: bold;
            }
          }
          .groupRight {
            color: #FFFFFF;
          }
          .countdown{
            display: flex;
            font-size: 14px;
            color: #FFFFFF;
            .countdownTit{
              line-height: 20px;
              margin-right: 5px;
            }
            .timeDown{
              span{
                display: inline-block;
                text-align: center;
                height: 20px;
                line-height: 20px;
              }
              .time{
                min-width: 20px;
                background-color: #fff;
                color: #FF6B63;
              }
            }
          }
        }
        .priceSpike {
          display: flex;
          margin-top: 15px;
          padding: 0 15px;
          justify-content: space-between;
          .priceSpikeLeft {
            display: flex;
            color: #EC4B42;
            align-items: center;
            font-size: 16px;
            b {
              color: $mainColor;
              font-size: 22px;
              margin-right: 10px;
            }
            span {
              font-size: 16px;
              font-weight: 400;
              text-decoration: line-through;
              color: #666666;
            }
          }
          .priceSpikeRight {
            display: flex;
            align-items: center;
            span {
              margin-right: 15px;
              color: #999999;
              font-size: 14px;
            }
            >>>.el-progress{
              box-sizing: border-box;
              width: 100px;
              height: 10px;
              border-radius: 0;
              border: 1px solid #FF736C;
              background: #F5F5F5;
              .el-progress-bar{
                display: block;
                height: 100%;
                .el-progress-bar__inner{
                  border-radius: 0;
                  height: 100%;
                }
                .el-progress-bar__outer{
                  border-radius: 0;
                  height: 100% !important;
                }
                .el-progress-bar__innerText{
                  display: none;
                }
              }
            }
          }
        }
        .promotionInfo {
          padding: 16px 16px 20px 16px;
          span:nth-child(1) {
            font-size: 16px;
            color: #999999;
          }
          span:nth-child(2) {
            font-size: 22px;
            color: $mainColor;
          }
          span:nth-child(3) {
            font-size: 16px;
            color: #666666;
            text-decoration: line-through;
          }
        }
        .proDiscount {
          padding: 2px 0 16px;
          max-height: 112px;
          overflow-y: auto;
          box-sizing: border-box;
          .discountInfo {
            span:nth-child(1) {
              font-size: 16px;
              color: #999999;
            }
            span:nth-child(2) {
              font-size: 14px;
              color: $mainColor;
              border: 1px solid $mainColor;
              padding: 0 2px;
              border-radius: 4px;
            }
            span:nth-child(3) {
              font-size: 14px;
              color: #666666;
            }
          }
          .activityLabel {
            padding-left: 20px;
            margin-bottom: 20px;
            span:nth-child(1) {
              font-size: 14px;
              color: $mainColor;
              border: 1px solid $mainColor;
              padding: 1px 2px;
              border-radius: 4px;
            }
            span:nth-child(2) {
              font-size: 14px;
              color: #666666;
            }
            span:nth-child(3) {
              font-size: 14px;
              color: $mainColor;
              text-decoration: underline;
              cursor: pointer;
            }
          }
          .activityLabel:last-child{
            margin-bottom: 0;
          }
        }
      }
      .proDescribeTit {
        color: #000000;
        font-size: 16px;
        margin: 18px 0;
      }
      .productColor {
        .proColorList {
          display: flex;
          div {
            border: 1px solid #FFFFFF;
            padding: 4px;
            margin-right: 15px;
            cursor: pointer;
            span {
              display: block;
              height: 37px;
              width: 37px;
              border: 1px solid #EEEEEE;
              img {
                width: 100%;
              }
            }
          }
          // div.colorActive {
          // }
        }
      }
      .sku-box {
        ul {
          li {
            p {
              &:nth-child(2) {
                span {
                  display: inline-flex;
                  padding: 0 1px;
                  height: 32px;
                  line-height: 32px;
                  text-align: center;
                  color: #666666;
                  font-size: 18px;
                  background: #EFEFEF;
                  margin-right: 20px;
                  margin-bottom: 15px;
                  cursor: pointer;
                }
                img {
                  height: 32px;
                  margin-right: 8px;
                }
                .selected-item {
                  background: $mainColor;
                  color: #FFFFFF;
                }
              }
            }
          }
        }
      }
      .productSize {
        .proSizeList {
          display: flex;
          span {
            padding: 0 10px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            color: #666666;
            font-size: 18px;
            background: #EFEFEF;
            margin-right: 20px;
            cursor: pointer;
          }
          span.sizeActive {
            background: $mainColor;
            color: #FFFFFF;
          }
        }
      }
      .proNumberList {
        .el-input-number {
          width: 140px;
          margin-right: 25px;
        }
        b {
          font-size: 16px;
          font-weight: 500;
          color: $mainColor;
          padding: 0 5px;
        }
      }
      .btnBox {
        display: flex;
        align-items: center;
        margin-top: 30px;
        .buyBox {
          display: flex;
          span {
            width: 135px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            font-size: 16px;
            color: $mainColor;
            border: 1px solid $mainColor;
            margin-right: 10px;
            &:hover {
              cursor: pointer;
            }
          }
          span:nth-child(2) {
            background: $mainColor;
            color: #FFFFFF;
          }
        }
        .favorites {
          display: flex;
          .StartGroup {
            width: 135px;
            height: 40px;
            background: #FF7800;
            display: block;
            color: #FFFFFF;
            text-align: center;
            line-height: 40px;
            cursor: pointer;
          }
          .oddBuy {
            width: 135px;
            height: 40px;
            display: block;
            box-sizing: border-box;
            color: $mainColor;
            border: 1px solid $mainColor;
            margin-right: 10px;
            text-align: center;
            line-height: 40px;
            cursor: pointer;
          }
        }
        .noStock{
          display: flex;
          span{
            width: 135px;
            height: 40px;
            background: #999999;
            display: block;
            color: #FFFFFF;
            text-align: center;
            line-height: 40px;
          }
        }
        .favoritesBtn {
          width: 40px;
          height: 38px;
          background: #FFFFFF;
          border: 1px solid #CCCCCC;
          text-align: center;
          margin-left: 10px;
          cursor: pointer;
          i {
            color: #666666;
            display: block;
            margin-top: 2px;
          }
          span {
            display: block;
            font-size: 12px;
            color: #999999;
          }
        }
      }
    }
  }
  >>> .el-tabs--border-card {
    box-shadow: none;
    border: none;
  }
  .productDetail {
    .detailTabs {
      margin-bottom: 30px;
      height: 46px;
      line-height: 46px;
      border: 1px solid #E5E5E5;
      background: #F6F6F6;
      display: flex;
      span {
        padding: 0 30px;
        border-right: 1px solid #E5E5E5;
        cursor: pointer;
        color: #333333;
        font-size: 16px;
      }
      .compActive {
        background: #FFFFFF;
      }
    }
    .detailBox {
      margin-bottom: 100px;
      .detailInfoBox {
        width: 890px;
        float: left;
        min-height: 1200px;
        border-right: 1px solid #CACACA;
      }
      .detailCont >>> img{ // 修改v-html渲染的样式
        max-width: 100%;
        height: auto;
      }
      .detailCont >>> ul{ // 修改v-html渲染的样式
        list-style-type: none;
      }
      .likeProductBox {
        width: 280px;
        float: left;
        padding-left: 44px;
      }
    }
  }
  .pinList {
    margin-top: 50px;
    border: 1px solid #E5E5E5;
    .fightOrderTit {
      display: flex;
      height: 60px;
      line-height: 60px;
      padding: 0 20px;
      border-bottom: 1px solid #E5E5E5;
      i {
        color: $mainColor;
        font-size: 28px;
      }
      span {
        color: #666666;
        font-size: 16px;
        margin-left: 10px;
      }
    }
    .pinListBox {
      padding: 0 30px;
      display: flex;
      // align-items: flex-start;
      flex-wrap: wrap;
      height: 110px;
      overflow-y: auto;
      .pinItem {
        flex: 0 0 33.33%;
        display: flex;
        align-items: center;
        margin: 25px 0;
        .Avatar {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 12px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .pinUserInfo {
          width: 125px;
          margin-right: 45px;
          span {
            display: block;
            font-size: 14px;
            b {
              font-weight: normal;
              color: $mainColor;
              letter-spacing: 3px;
            }
          }
          span:nth-child(1) {
            color: #333333;
            margin-bottom: 5px;
          }
          span:nth-child(2) {
            color: #666666;
            margin-bottom: 5px;
          }
          span:nth-child(3) {
            color: #999999;
          }
        }
        .pinBtn {
          width: 120px;
          height: 40px;
          border: 1px solid #FF7800;
          text-align: center;
          line-height: 40px;
          cursor: pointer;
          font-size: 16px;
          color: $mainColor;
        }
      }
    }
  }
}
.pinListBox::-webkit-scrollbar {
  width: 4px;
  height: 16px;
  background-color: #F5F5F5;
}
/*定义滚动条轨道 内阴影+圆角*/
.pinListBox::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
  border-radius: 0px;
  background-color: #FFFFFF;
}
/*定义滑块 内阴影+圆角*/
.pinListBox::-webkit-scrollbar-thumb {
  border-radius: 0px;
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.1);
  background-color: #e3e3e3;
}
</style>



// WEBPACK FOOTER //
// src/views/product/productDetail.vue